import { lazy } from "react";
import type { AppPageRouteConfig } from "Routes/renderAppPageRoute";

const singlePageRoutes: AppPageRouteConfig[] = [
    {
        path: "/subscription",
        permission: "subscription",
        component: lazy(() => import("Pages/subscription/Subscription")),
    },
    {
        path: "/merchant_orders",
        permission: "merchant_orders",
        component: lazy(() => import("Pages/merchant/MerchantOrders")),
    },
    {
        path: "/products",
        permission: "products",
        component: lazy(() => import("Pages/ProductsTab/CommonProductsWrapper")),
    },
    {
        path: "/product_management",
        permission: "nokia_products",
        component: lazy(() => import("Pages/product-master/ProductManagement/ProductManagementBody")),
    },
    {
        path: "/quotations",
        permission: "quotations",
        component: lazy(() => import("Pages/marketplace/quotations/Quotations")),
    },
    {
        path: "/account",
        permission: "account",
        component: lazy(() => import("Pages/subscription/Account/index")),
    },
    {
        path: "/users",
        permission: "users",
        component: lazy(() => import("Pages/admin/Admin")),
    },
    {
        path: "/roles",
        permission: "users",
        component: lazy(() => import("Pages/admin/roles-management/Roles")),
    },
    {
        path: "/orders",
        permission: "common_orders",
        component: lazy(() => import("Pages/OrdersTab/CommonOrdersWrapper")),
    },
    {
        path: "/stock_inventory",
        permission: "stock_inventory",
        component: lazy(() => import("Pages/merchant/StockInventory/StockInventory")),
    },
    {
        path: "/pricing/analyse/profitability/:offerId",
        permission: "pricing",
        component: lazy(() => import("Pages/Profitability/Analyse/ProfitabilityAnalysis")),
    },
    {
        path: "/pricing",
        permission: "pricing",
        component: lazy(() => import("Pages/Profitability/Profitability")),
    },
    {
        path: "/user_onboarding",
        permission: "onboarding",
        component: lazy(() => import("Pages/Onboarding/Onboarding")),
    },
    {
        path: "/deal_registration/*",
        permission: "deal_registration",
        component: lazy(() => import("Routes/features/dealRegistration.routes")),
    }
];

const featureRoutes: AppPageRouteConfig[] = [
    {
        path: "/marketplace/*",
        permission: "marketplace",
        component: lazy(() => import("Routes/features/marketplace.routes")),
    },
    {
        path: "/dashboard/*",
        permission: "dashboard",
        component: lazy(() => import("Routes/features/dashboard.routes")),
    },
    {
        path: "/assets/*",
        permission: "assets",
        component: lazy(() => import("Routes/features/assets.routes")),
    },
    {
        path: "/tasks/*",
        permission: "tasks",
        component: lazy(() => import("Routes/features/tasks.routes")),
    },
    {
        path: "/installed_base/*",
        permission: "installed_base",
        component: lazy(() => import("Routes/features/installed_base.routes")),
    },
    {
        path: "/pta/*",
        permission: "offer",
        component: lazy(() => import("Routes/features/pta.routes")),
    },
    {
        path: "/ciq/*",
        permission: "ciq",
        component: lazy(() => import("Routes/features/ciq.routes")),
    },
    {
        path: "/radio_network_ciq/*",
        permission: "radio_network_ciq",
        component: lazy(() => import("Routes/features/radio_network_ciq.routes")),
    },
    {
        path: "/networks/*",
        permission: "networks",
        component: lazy(() => import("Routes/features/networks.routes")),
    },
    {
        path: "/d2c/*",
        permission: "networks",
        component: lazy(() => import("Routes/features/d2c.routes")),
    },
    {
        path: "/offer/*",
        permission: "offer",
        component: lazy(() => import("Routes/features/offer.routes")),
    },
    {
        path: "/contract/*",
        permission: "contract",
        component: lazy(() => import("Routes/features/contract.routes")),
    },
    {
        path: "/deal_registration/*",
        permission: "deal_registration",
        component: lazy(() => import("Routes/features/dealRegistration.routes")),
    }
];

// Redirects and 404 fallback. Do not move `path: "*"` above other routes.
const redirectAndFallbackRoutes: AppPageRouteConfig[] = [
    {
        path: "/frame_agreement",
        redirectTo: "/contract",
    },
    {
        path: "/onboarding_registration",
        redirectTo: "/user_onboarding",
    },
    {
        path: "/unauthorized",
        component: lazy(() => import("Pages/Unauthorized")),
    },
    {
        path: "*",
        component: lazy(() => import("Pages/Unauthorized")),
    },
];

// Do not reorder: specific paths first, feature `/*` routes next, fallbacks last.
export const appPageRoutes: AppPageRouteConfig[] = [
    ...singlePageRoutes,
    ...featureRoutes,
    ...redirectAndFallbackRoutes,
];
